import React from "react";
import { Icon, SvgIconProps } from "@material-ui/core";
import styled from "styled-components";

const IconContainer = styled.div`
    display: flex;
`;

const BackgroundIcon = styled(Icon)`
    &&& {
        color: white;
        position: absolute;
    }
`;

const ForegroundIcon = styled(Icon)`
    &&& {
        position: relative;
        z-index: 1;
    }
`;

// UpgradeIcon with a white circle background and a yellow stars foreground
// setting the color changes the icon but not the inner fill color
export function UpgradeIcon({ color = "#ffaa00", fontSize = "small" }: {
    color?: string,
    fontSize?: SvgIconProps["fontSize"]
}) {
    return (
        <IconContainer>
            <BackgroundIcon fontSize={fontSize}>circle</BackgroundIcon>
            <ForegroundIcon style={{ color }} fontSize={fontSize}>stars</ForegroundIcon>
        </IconContainer>
    );
}

export default UpgradeIcon;
